import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/WhyBook.css';
import { getAppEnv } from '../../../../config/env';
import { WHY_BOOK_WITH_US_TITLE } from '../../../utils/RailsSEOConstants';

const env = getAppEnv();
const { PUBLIC_URL } = env.raw;

export const WhyBook = ({ customClass, usps }) => {
  return (
    <section>
      <h2>{WHY_BOOK_WITH_US_TITLE}</h2>
      <ul className={`whyBook ${customClass}`}>
        {usps &&
          usps.map(({ uspTitle, uspDescription, logoUrl }, index) => {
            return (
              <li key={index}>
                <img src={`${PUBLIC_URL}/static/public/${logoUrl}`} width="52px" height="52px" alt={uspTitle} />
                <div className={'appendLeft5'}>
                  <p className="appendBottom2 font18 latoBlack blackText lineHeight20">{uspTitle}</p>
                  <p className="font16 darkGreyText lineHeight18">{uspDescription}</p>
                </div>
              </li>
            );
          })}
      </ul>
    </section>
  );
};

WhyBook.propTypes = {
  usps: PropTypes.array,
  customClass: PropTypes.string
};

export default WhyBook;
